import { useContext, useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import api from '../../../services/api'
import Swal from 'sweetalert2'
import { MainContext } from '../../../context/MainContext'

const STATUS_OPTIONS = [
  { value: 'soon', label: 'Em breve' },
  { value: 'in_progress', label: 'Em andamento' },
  { value: 'finished', label: 'Finalizado' },
]

export default function EditEventStage() {
  const { id } = useParams()
  const navigate = useNavigate()
  const { setPageTitle, setLoading } = useContext(MainContext)

  const [form, setForm] = useState({
    title: '',
    description: '',
    stage: '',
    status: 'soon',
    series: 0,
    maximum_inscriptions: 0,
    time_interval: '' as any,
    show_result: false,
    active: true,
    final: '0',
  })

  useEffect(() => {
    setLoading(true)
    api
      .get(`/api/event_stages/${id}`)
      .then((res) => {
        const s = res.data
        setForm({
          title: s.title ?? '',
          description: s.description ?? '',
          stage: s.stage ?? '',
          status: s.status ?? 'soon',
          series: s.series ?? 0,
          maximum_inscriptions: s.maximum_inscriptions ?? 0,
          time_interval: s.time_interval ?? '',
          show_result: !!s.show_result,
          active: !!s.active,
          final: s.final ?? '0',
        })
      })
      .catch(() => Swal.fire({ title: 'Erro!', text: 'Etapa não encontrada', icon: 'error' }).then(() => navigate(-1)))
      .finally(() => setLoading(false))
  }, [])

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => {
    const { name, value, type } = e.target
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? (e.target as HTMLInputElement).checked : value,
    }))
  }

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    try {
      setLoading(true)
      await api.put(`/api/event_stages/${id}`, {
        ...form,
        time_interval: form.time_interval === '' ? null : Number(form.time_interval),
      })
      Swal.fire({ title: 'Sucesso!', text: 'Etapa atualizada com sucesso!', icon: 'success', timer: 3000 }).then(() =>
        navigate(-1)
      )
    } catch (err: any) {
      Swal.fire({ title: 'Erro!', text: err?.response?.data?.message || err, icon: 'error' })
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="col-lg-12">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Editar Etapa</h5>
          <form onSubmit={handleSubmit} autoComplete="off">
            <div className="row g-3">

              <div className="col-md-8">
                <label className="form-label">Título <i className="text-danger">*</i></label>
                <input name="title" className="form-control" value={form.title} onChange={handleChange} required />
              </div>

              <div className="col-md-4">
                <label className="form-label">Etapa</label>
                <input name="stage" className="form-control" value={form.stage} onChange={handleChange} />
              </div>

              <div className="col-md-12">
                <label className="form-label">Descrição</label>
                <textarea name="description" className="form-control" rows={3} value={form.description} onChange={handleChange} />
              </div>

              <div className="col-md-4">
                <label className="form-label">Status <i className="text-danger">*</i></label>
                <select name="status" className="form-select" value={form.status} onChange={handleChange}>
                  {STATUS_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </div>

              <div className="col-md-4">
                <label className="form-label">Séries</label>
                <input name="series" type="number" className="form-control" value={form.series} onChange={handleChange} />
              </div>

              <div className="col-md-4">
                <label className="form-label">Máx. inscrições</label>
                <input name="maximum_inscriptions" type="number" className="form-control" value={form.maximum_inscriptions} onChange={handleChange} />
              </div>

              <div className="col-md-4">
                <label className="form-label">Intervalo de tempo (s)</label>
                <input name="time_interval" type="number" className="form-control" value={form.time_interval} onChange={handleChange} />
              </div>

              <div className="col-md-4">
                <label className="form-label">Final</label>
                <select name="final" className="form-select" value={form.final} onChange={handleChange}>
                  <option value="0">Não</option>
                  <option value="1">Sim</option>
                </select>
              </div>

              <div className="col-md-4 d-flex align-items-end gap-4 pb-1">
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="show_result" id="show_result"
                    checked={form.show_result} onChange={handleChange} />
                  <label className="form-check-label" htmlFor="show_result">Exibir resultado</label>
                </div>
                <div className="form-check">
                  <input className="form-check-input" type="checkbox" name="active" id="active"
                    checked={form.active} onChange={handleChange} />
                  <label className="form-check-label" htmlFor="active">Ativo</label>
                </div>
              </div>

              <div className="col-12 d-flex gap-2">
                <button type="submit" className="btn btn-success">
                  <i className="bi bi-floppy2">&nbsp;</i>Salvar
                </button>
                <button type="button" className="btn btn-danger" onClick={() => navigate(-1)}>
                  <i className="bi bi-x-circle-fill">&nbsp;</i>Cancelar
                </button>
              </div>

            </div>
          </form>
        </div>
      </div>
    </div>
  )
}
